var map = {
	"./add.svg": 4780,
	"./alert.svg": 8342,
	"./arrow-left.svg": 1833,
	"./arrow-right.svg": 153,
	"./completed.svg": 9138,
	"./delete.svg": 2539,
	"./detail.svg": 5307,
	"./download.svg": 9007,
	"./dummy.svg": 953,
	"./edit.svg": 8377,
	"./error.svg": 9687,
	"./excel.svg": 2915,
	"./home.svg": 2520,
	"./index.svg": 1610,
	"./inprogress.svg": 9670,
	"./logout.svg": 2990,
	"./off.svg": 1586,
	"./on.svg": 7454,
	"./return.svg": 1180,
	"./save.svg": 3884,
	"./settings.svg": 677,
	"./upload.svg": 377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;